module.exports = __webpack_public_path__ + "img/desc_bottom_hc3620.de1b59a2.png";